// @need-translate
import {SelectV2Option} from '../../design-system/molecules/SelectV2/SelectV2Props.interface';
import {MainTabItemType} from '../../design-system/organisms/MainTab/MainTabItemType.interface';

export enum AskTabType {
  Request = 'request',
  My = 'my',
}

export enum ASK_PROJECT_ID {
  Page = 'page', // 카카오페이지 국내
  PageGlobal = 'pageglobal', // 카카오페이지 글로벌
}

export const ASK_TAB_ITEMS: MainTabItemType[] = [
  {
    id: AskTabType.Request,
    text: '서비스 문의',
    textTKey: 'more_customer_cs_inquiry_tab',
    href: `/ask?tab=${AskTabType.Request}`,
  },
  {
    id: AskTabType.My,
    text: '내 문의내역',
    textTKey: 'more_customer_cs_my_history_tab',
    href: `/ask?tab=${AskTabType.My}`,
  },
];

/**
 * 문의 유형. querystring askType그대로 사용되니 변경 시 주의
 */
export enum AskType {
  Default = 'default',
  /**
   * 서비스 이용 관련
   */
  ServiceUse = 'service_use',
  /**
   * 캐시 관련
   */
  Cash = 'cash',
  /**
   * 캐시 충전 오류 관련
   */
  CashChargeError = 'cash_charge_error',
  /**
   * 캐시 환불 관련
   */
  CashRefund = 'cash_refund',
  /**
   * 이용권 관련
   */
  PassUse = 'pass_use',
  /**
   * 캐시프렌즈
   */
  CashFriends = 'cashfriends',
  /**
   * 캐시프렌즈(쇼핑하기)
   */
  CashFriendsShopping = 'cashfriends_shopping',
  /**
   * 이용 장애
   */
  ServiceError = 'service_error',
  /**
   * 콘텐츠 관련
   */
  Content = 'content',
  /**
   * 이벤트 관련
   */
  Event = 'event',
  /**
   * 개선 제안
   */
  Suggestion = 'suggestion',
  /**
   * 권리침해/불법 촬영물 등 유통 신고
   */
  RightsInfringement = 'right',
}

export const ASK_TYPE_TRANS_KEY_MAP = {
  [AskType.ServiceUse]: 'more_customer_cs_inquiry_tab_category_general',
  [AskType.Cash]: 'more_customer_cs_inquiry_tab_category_cash',
  [AskType.CashChargeError]:
    'more_customer_cs_inquiry_tab_category_charge_problems',
  [AskType.CashRefund]: 'more_customer_cs_inquiry_tab_category_refund_cash',
  [AskType.PassUse]: 'more_customer_cs_inquiry_tab_category_ticket',
  [AskType.CashFriends]: 'more_customer_cs_inquiry_tab_category_cashfriends',
  [AskType.CashFriendsShopping]:
    'more_customer_cs_inquiry_tab_category_cashfriends_shopping',
  [AskType.ServiceError]: 'more_customer_cs_inquiry_tab_category_problems',
  [AskType.Content]: 'more_customer_cs_inquiry_tab_category_contents',
  [AskType.Event]: 'more_customer_cs_inquiry_tab_category_events',
  [AskType.Suggestion]: 'more_customer_cs_inquiry_tab_category_suggestions',
  [AskType.RightsInfringement]:
    'more_customer_cs_inquiry_tab_category_report_rights',
} as const;

export const ASK_TYPE_OPTIONS = Object.values(AskType);

export const ASK_CATEGORY_KO_OPTIONS: SelectV2Option[] = [
  {
    text: '서비스 이용 관련',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.ServiceUse],
    value: AskType.ServiceUse,
  },
  {
    text: '캐시 관련',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.Cash],
    value: AskType.Cash,
  },
  {
    text: '캐시 충전 오류 관련',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.CashChargeError],
    value: AskType.CashChargeError,
  },
  {
    text: '캐시 환불 관련',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.CashRefund],
    value: AskType.CashRefund,
  },
  {
    text: '이용권 관련',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.PassUse],
    value: AskType.PassUse,
  },
  {
    text: '캐시프렌즈',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.CashFriends],
    value: AskType.CashFriends,
  },
  {
    text: '캐시프렌즈(쇼핑하기)',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.CashFriendsShopping],
    value: AskType.CashFriendsShopping,
  },
  {
    text: '이용 장애',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.ServiceError],
    value: AskType.ServiceError,
  },
  {
    text: '콘텐츠 관련',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.Content],
    value: AskType.Content,
  },
  {
    text: '이벤트 관련',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.Event],
    value: AskType.Event,
  },
  {
    text: '개선 제안',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.Suggestion],
    value: AskType.Suggestion,
  },
  {
    text: '권리침해/불법 촬영물 등 유통 신고',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.RightsInfringement],
    value: AskType.RightsInfringement,
  },
];

export const ASK_CATEGORY_GLOBAL_OPTIONS: SelectV2Option[] = [
  {
    text: '서비스 이용 관련',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.ServiceUse],
    value: AskType.ServiceUse,
  },
  {
    text: '캐시 관련',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.Cash],
    value: AskType.Cash,
  },
  {
    text: '이용 장애',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.ServiceError],
    value: AskType.ServiceError,
  },
  {
    text: '콘텐츠 관련',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.Content],
    value: AskType.Content,
  },
  {
    text: '개선 제안',
    textTKey: ASK_TYPE_TRANS_KEY_MAP[AskType.Suggestion],
    value: AskType.Suggestion,
  },
];

export enum AskSubCategory {
  Android = 'Android',
  Ios = 'Ios',
  Web = 'Web',
  Default = 'Default',
}

export const ASK_SUB_CATEGORY_OPTIONS: SelectV2Option[] = [
  {
    text: 'android',
    // @ts-expect-error
    textTKey: '',
    value: AskSubCategory.Android,
  },
  {
    text: 'ios',
    // @ts-expect-error
    textTKey: '',
    value: AskSubCategory.Ios,
  },
  {
    text: 'web',
    // @ts-expect-error
    textTKey: '',
    value: AskSubCategory.Web,
  },
];

export const MAX_FILE_SIZE = 30 * 1024 * 1024;
export const MAX_FILES = 5;

export const ASK_NUM_PER_PAGE = 10;

export const CATEGORY_ID_MAP = {
  [AskType.ServiceUse]: {
    [AskSubCategory.Android]: 10011,
    [AskSubCategory.Ios]: 10012,
    [AskSubCategory.Web]: 10013,
  },
  [AskType.Cash]: {
    [AskSubCategory.Android]: 10027,
    [AskSubCategory.Ios]: 10028,
    [AskSubCategory.Web]: 10029,
  },
  [AskType.CashChargeError]: {
    [AskSubCategory.Android]: 10043,
    [AskSubCategory.Ios]: 10044,
    [AskSubCategory.Web]: 10045,
  },
  [AskType.CashRefund]: {
    [AskSubCategory.Android]: 10047,
    [AskSubCategory.Ios]: 10048,
    [AskSubCategory.Web]: 10049,
  },
  [AskType.PassUse]: {
    [AskSubCategory.Android]: 10051,
    [AskSubCategory.Ios]: 10052,
    [AskSubCategory.Web]: 10053,
  },
  [AskType.CashFriends]: {
    [AskSubCategory.Android]: 10031,
    [AskSubCategory.Ios]: 10032,
    [AskSubCategory.Web]: 10033,
  },
  [AskType.CashFriendsShopping]: {
    [AskSubCategory.Android]: 10035,
    [AskSubCategory.Ios]: 10036,
    [AskSubCategory.Web]: 10037,
  },
  [AskType.ServiceError]: {
    [AskSubCategory.Android]: 10019,
    [AskSubCategory.Ios]: 10020,
    [AskSubCategory.Web]: 10021,
  },
  [AskType.Content]: {
    [AskSubCategory.Android]: 10039,
    [AskSubCategory.Ios]: 10040,
    [AskSubCategory.Web]: 10041,
  },
  [AskType.Event]: {
    [AskSubCategory.Android]: 10015,
    [AskSubCategory.Ios]: 10016,
    [AskSubCategory.Web]: 10017,
  },
  [AskType.Suggestion]: {
    [AskSubCategory.Android]: 10003,
    [AskSubCategory.Ios]: 10004,
    [AskSubCategory.Web]: 10005,
  },
  [AskType.RightsInfringement]: {
    [AskSubCategory.Android]: 10007,
    [AskSubCategory.Ios]: 10008,
    [AskSubCategory.Web]: 10009,
  },
} as const;

export const CATEGORY_ID_MAP_GLOBAL = {
  [AskType.ServiceUse]: {
    [AskSubCategory.Android]: 11764,
    [AskSubCategory.Ios]: 11765,
    [AskSubCategory.Web]: 11766,
  },
  [AskType.Suggestion]: {
    [AskSubCategory.Android]: 11768,
    [AskSubCategory.Ios]: 11769,
    [AskSubCategory.Web]: 11770,
  },
  [AskType.ServiceError]: {
    [AskSubCategory.Android]: 11772,
    [AskSubCategory.Ios]: 11773,
    [AskSubCategory.Web]: 11774,
  },
  [AskType.Content]: {
    [AskSubCategory.Android]: 11776,
    [AskSubCategory.Ios]: 11777,
    [AskSubCategory.Web]: 11778,
  },
  [AskType.Cash]: {
    [AskSubCategory.Android]: 11781,
    [AskSubCategory.Ios]: 11783,
    [AskSubCategory.Web]: 11785,
  },
  [AskType.CashChargeError]: {
    [AskSubCategory.Android]: undefined,
    [AskSubCategory.Ios]: undefined,
    [AskSubCategory.Web]: undefined,
  },
  [AskType.CashRefund]: {
    [AskSubCategory.Android]: undefined,
    [AskSubCategory.Ios]: undefined,
    [AskSubCategory.Web]: undefined,
  },
  [AskType.PassUse]: {
    [AskSubCategory.Android]: undefined,
    [AskSubCategory.Ios]: undefined,
    [AskSubCategory.Web]: undefined,
  },
  [AskType.CashFriends]: {
    [AskSubCategory.Android]: undefined,
    [AskSubCategory.Ios]: undefined,
    [AskSubCategory.Web]: undefined,
  },
  [AskType.CashFriendsShopping]: {
    [AskSubCategory.Android]: undefined,
    [AskSubCategory.Ios]: undefined,
    [AskSubCategory.Web]: undefined,
  },
  [AskType.Event]: {
    [AskSubCategory.Android]: undefined,
    [AskSubCategory.Ios]: undefined,
    [AskSubCategory.Web]: undefined,
  },
  [AskType.RightsInfringement]: {
    [AskSubCategory.Android]: undefined,
    [AskSubCategory.Ios]: undefined,
    [AskSubCategory.Web]: undefined,
  },
} as const;

export const PHONE_EXCLUDED_REGEX = /[^0-9-+ ]/g;
export const BANK_ACCOUNT_EXCLUDED_REGEX = /[^0-9- ]/g;

export const ALLOWED_FILE_EXTENSIONS = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.bmp',
  '.webp',
  '.tiff',
  '.tif',
  '.svg',
  '.heic',
  '.heif',
  '.mp4',
  '.mov',
  '.avi',
  '.wmv',
  '.mkv',
  '.webm',
  '.flv',
  '.mpeg',
  '.mpg',
  '.m4v',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.txt',
  '.rtf',
  '.odt',
  '.ods',
  '.odp',
  '.csv',
];
